import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

export interface ConfirmData {
  title: string;
  text: string;
  yesText?: string;
  noText?: string;
}

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmData) {
    if (!data.yesText) {
      data.yesText = 'Ja';
    }
    if (!data.noText) {
      data.noText = 'Nee';
    }
  }

  ngOnInit() {}
}
